import { toFixed } from '../../../../core/services/utils/numbers';

/** Representa o ROI da campanha */
export interface CampanhaROI {
    valorTotalVendas: number;
    valorTotalDespesas: number;
    pontoEquilibrio: number;
    valor: number;
    retorno: number;
    retornoEfetivo: number;
    perc: number;
}

/** cria um novo ROI da campanha */
export function newCampanhaROI(valorTotalPedidosVendas: number, valorTotalDespesas: number, pontoEquilibrio: number): CampanhaROI {
	const roi: CampanhaROI = {
		valorTotalVendas:   valorTotalPedidosVendas,
		valorTotalDespesas,
		pontoEquilibrio,
		valor:              0,
		retorno:            0,
		retornoEfetivo:     0,
		perc:               0,
	}
	// Calculando valor do ROI
	roi.valor = calcularValor(roi.valorTotalVendas, roi.valorTotalDespesas);
	// Calculando o retorno do ROI
	roi.retorno = calcularRetorno(roi.valorTotalVendas, roi.valorTotalDespesas);
	// Calculando o retorno efetivo do ROI
	roi.retornoEfetivo = calcularRetornoEfetivo(roi.valorTotalVendas, roi.valorTotalDespesas, roi.pontoEquilibrio);
	// Calculando perc do ROI
	roi.perc = calcularPerc(roi.valorTotalVendas, roi.valorTotalDespesas);

	return roi;
}

/** Calcula o valor do ROI subtraindo o valor dos pedidos de vendas pelo total das despesas */
export function calcularValor(valorTotalVendas: number, valorTotalDespesas: number): number {
    valorTotalVendas = valorTotalVendas && !isNaN(valorTotalVendas) ? Number(valorTotalVendas) : 0;
    valorTotalDespesas = valorTotalDespesas && !isNaN(valorTotalDespesas) ? Number(valorTotalDespesas) : 0;

    const valor = valorTotalVendas - valorTotalDespesas;
    return toFixed(valor, 2);
}

/** Calcula o retorno do ROI dividindo o valor do ROI pelo total das despesas */
export function calcularRetorno(valorTotalVendas: number, valorTotalDespesas: number): number {
    valorTotalVendas = valorTotalVendas && !isNaN(valorTotalVendas) ? Number(valorTotalVendas) : 0;
    valorTotalDespesas = valorTotalDespesas && !isNaN(valorTotalDespesas) ? Number(valorTotalDespesas) : 0;

	if (valorTotalVendas === 0 || valorTotalDespesas === 0) {
		return 0;
	} else if (valorTotalDespesas === 0) {
		return 0;
	}

	const valor = calcularValor(valorTotalVendas, valorTotalDespesas);
	const retorno = valor / valorTotalDespesas;
	return toFixed(retorno, 2);
}

/** Calcula o retorno efetivo do ROI subtraindo o retorno da campanha pelo ponto de equilíbrio */
export function calcularRetornoEfetivo(valorTotalVendas: number, valorTotalDespesas: number, pontoEquilibrio: number): number {
    valorTotalVendas = valorTotalVendas && !isNaN(valorTotalVendas) ? Number(valorTotalVendas) : 0;
    valorTotalDespesas = valorTotalDespesas && !isNaN(valorTotalDespesas) ? Number(valorTotalDespesas) : 0;
    pontoEquilibrio = pontoEquilibrio && !isNaN(pontoEquilibrio) ? Number(pontoEquilibrio) : 0;

	if (valorTotalVendas === 0 || valorTotalDespesas === 0) {
		return 0;
	}

	const retorno = calcularRetorno(valorTotalVendas, valorTotalDespesas);
	const retornoEfetivo = retorno - pontoEquilibrio;
	return toFixed(retornoEfetivo, 2);
}

/** Calcula o percentual do ROI multiplicando retorno por 100 */
export function calcularPerc(valorTotalVendas: number, valorTotalDespesas: number): number {
    valorTotalVendas = valorTotalVendas && !isNaN(valorTotalVendas) ? Number(valorTotalVendas) : 0;
    valorTotalDespesas = valorTotalDespesas && !isNaN(valorTotalDespesas) ? Number(valorTotalDespesas) : 0;

	if (valorTotalVendas === 0 || valorTotalDespesas === 0) {
		return 0;
	} else if (valorTotalDespesas === 0) {
		return 0;
	}

	const valor = calcularValor(valorTotalVendas, valorTotalDespesas);
	const perc = (valor / valorTotalDespesas) * 100;
	return toFixed(perc, 2);
}
